
export class ReceiptPaperDetail {
    id: string;
    receipt_paper_id: string;
    name: string | null;
    unit_price: number;
    quantity: number;
    tax_rate: number;
    price: number;
    is_naizei: boolean;
    tax: number;
}

export function createEmptyReceiptPaperDetail(): ReceiptPaperDetail {
  return {
    id: null,
    name: '',
    receipt_paper_id: '',
    unit_price: 0,
    quantity: 0,
    tax_rate: 10,
    price: 0,
    is_naizei: false,
    tax: 0,
  };
}
